import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from "../router"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    schemeType: localStorage.getItem('schemeType') || '',
    user : localStorage.getItem('user') || ''
  },
  mutations: {
      auth_request(state){
          state.status = 'loading'
      },
      auth_success(state, data){

          state.status = 'success'
          state.token = data.token
          state.user = data.user
      },
      auth_schemeType(state, schemeType){
          state.schemeType = schemeType
      },
      auth_error(state){
          state.status = 'error'
      },
      logout(state){
          state.status = ''
          state.token = ''
          state.schemeType = ''
      },
  },
  actions: {
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios
            .post( '/identityservice/v1/user/authenticate', user )
            .then(resp => {
              const token = resp.data.jwtToken
              const user = resp.data.user.userName
              localStorage.setItem('token', token)
              localStorage.setItem('user', user)
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
              commit('auth_success', {token, user})
                axios.get('/userservice/v1/User/current').then(
                    response => {
                        const schemeType = response.data.schemeType
                        localStorage.setItem('schemeType', schemeType)
                        commit('auth_schemeType', schemeType)
                    }
                ).catch(error => {
                    console.log('error_get_data');
                    console.log(error);
                    this.errored = true;
                })
              resolve(resp)
            })
            .catch(err => {
              commit('auth_error')
              localStorage.removeItem('token')
                localStorage.removeItem('user')
              reject(err)
            })
      })
    },
      refresh({commit}) {

          return new Promise((resolve, reject) => {
              commit('logout')
              console.log("refresh")
              const token = localStorage.getItem('token')
              if (token){
                  delete axios.defaults.headers.common['Authorization']
                  localStorage.removeItem('token')
                  axios({url: '/identityservice/v1/user/refresh-token', method: 'POST' })
                      .then(resp => {
                          const token = resp.data.jwtToken
                          const user = resp.data.user.userName
                          localStorage.setItem('token', token)
                          localStorage.setItem('user', user)
                          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                          commit('auth_success', {token, user})
                          axios.get('/userservice/v1/User/current').then(
                              response => {
                                  const schemeType = response.data.schemeType
                                  localStorage.setItem('schemeType', schemeType)
                                  commit('auth_schemeType', schemeType)
                              }
                          ).catch(error => {
                              console.log('error_get_data');
                              console.log(error);
                              this.errored = true;
                          })
                          resolve(resp)
                      })
                      .catch(err => {
                          reject(err)
                      })
              } else {
                  delete axios.defaults.headers.common['Authorization']
                  router.push('/login')
              }
          })
      },
      logout({commit}) {
          return new Promise((resolve, reject) => {
              commit('logout')
              delete axios.defaults.headers.common['Authorization']
              axios({url: '/identityservice/v1/user/revoke-token', method: 'POST', data: {},  withCredentials: true })
                  .then(resp => {
                      localStorage.removeItem('token')
                      localStorage.removeItem('user')
                      localStorage.removeItem('schemeType')
                      resolve(resp)
                  })
                  .catch(err => {
                      localStorage.removeItem('user')
                      localStorage.removeItem('schemeType')
                      reject(err)
                  })
              //router.push('/login')
          })
      }
  },
  modules: {
  },
  getters : {
      isLoggedIn: state => !!state.token,
      authStatus: state => state.status,
  }
})
